import { createFileRoute } from '@tanstack/react-router';
import { SecurityPage } from '@/components/marketing/pages/SecurityPage';

export const Route = createFileRoute('/_marketing/security')({
  component: SecurityPage,
});
